import React from 'react'
import PropTypes from 'prop-types'

const StorePage = ({ children }) => (
  <div className='container-fluid'>
    <div className='container container-all-categories'>
      <div className='row'>
        <div className='col-12 py-3'>
          <div className='row'>
            <div className='col-12 border-color-ui-3 bg-white border radius'>
              <div className='col-12 pt-3 px-3'>{children}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

StorePage.propTypes = {
  children: PropTypes.any.isRequired
}

export default StorePage



// WEBPACK FOOTER //
// ./src/features/Store/StorePage.js